import React from 'react';
import { Mail, Phone, LinkedinIcon } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const navLinks = [
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'Use Cases', id: 'use-cases' },
    { label: 'Languages', id: 'languages' },
    { label: 'Pricing', id: 'pricing' },
    { label: 'Recognition', id: 'recognition' },
  ];

  return (
    <footer
      id="contact"
      data-testid="footer"
      className="bg-[#1C1917] text-white py-14 border-t border-[#292524]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-10 md:gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img src="/neurobloom-logo.png" alt="Neurobloom" className="h-9 w-9 rounded-xl" />
              <span className="font-semibold text-xl font-['DM_Sans']">Neurobloom</span>
            </div>
            <p className="text-[#A8A29E] mb-6 max-w-sm text-sm leading-relaxed">
              AI voice agents for Indian D2C brands. Recover carts, confirm COD orders,
              and follow up post-purchase — in your customers' language.
            </p>

            <div className="space-y-2">
              <a
                href="mailto:contact@neurobloomai.com"
                data-testid="footer-email"
                className="flex items-center gap-2 text-[#A8A29E] hover:text-white transition-colors text-sm"
              >
                <Mail className="w-4 h-4 flex-shrink-0" />
                contact@neurobloomai.com
              </a>
              <a
                href="tel:+919346614713"
                data-testid="footer-phone-1"
                className="flex items-center gap-2 text-[#A8A29E] hover:text-white transition-colors text-sm"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                +91 93466 14713
              </a>
              <a
                href="tel:+919490544108"
                data-testid="footer-phone-2"
                className="flex items-center gap-2 text-[#A8A29E] hover:text-white transition-colors text-sm"
              >
                <Phone className="w-4 h-4 flex-shrink-0" />
                +91 94905 44108
              </a>
              <a
                href="https://www.linkedin.com/company/neuro-bloom-ai/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="flex items-center gap-2 text-[#A8A29E] hover:text-white transition-colors text-sm"
              >
                <LinkedinIcon className="w-4 h-4 flex-shrink-0" />
                LinkedIn
              </a>
            </div>
          </div>

          {/* Nav */}
          <div>
            <h4 className="font-['DM_Sans'] font-semibold text-sm uppercase tracking-wider text-[#78716C] mb-4">
              Navigation
            </h4>
            <ul className="space-y-3">
              {navLinks.map((link, index) => (
                <li key={index}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-[#A8A29E] hover:text-white transition-colors text-sm"
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Recognised by */}
        <div className="mt-12 pt-8 border-t border-[#292524]">
          <p className="text-[#78716C] text-xs font-medium uppercase tracking-widest text-center mb-6">
            Recognised by
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-5">
            <a
              href="https://t-hub.co"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl px-5 py-3 flex items-center gap-3 hover:opacity-80 transition-opacity"
            >
              <img
                src="/thub-logo.svg"
                alt="T-Hub Recognised Startup"
                className="h-10 w-10 object-contain"
              />
              <div>
                <div className="text-[#1C1917] font-bold text-sm leading-tight">T-Hub</div>
                <div className="text-[#57534E] text-xs">Recognised Startup</div>
              </div>
            </a>
            <a
              href="https://www.startupindia.gov.in"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white rounded-xl px-5 py-3 flex items-center justify-center hover:opacity-80 transition-opacity"
            >
              <img
                src="/dpiit-header.png"
                alt="DPIIT Startup India Recognised"
                className="h-10 object-contain"
              />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-8 pt-6 border-t border-[#292524] flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[#57534E] text-sm">
            © 2025 Neurobloom AI · Made with pride in India 🇮🇳
          </p>
          <p className="text-[#57534E] text-sm">contact@neurobloomai.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
